
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart/ui",
      function () {
        return require("private-next-pages/cart/ui/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cart/ui"])
      });
    }
  